import {
  Component,
  AfterViewInit,
  OnChanges,
  Input,
  NgZone,
  ChangeDetectorRef,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  SimpleChange,
  SimpleChanges,
  OnInit
} from "@angular/core";

import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";

import { Donation } from "../models/donation";

import { DataService } from "../services/data.service";

import { Message } from "primeng/primeng";

import { def_msg_len, error_msg_len } from "../utils";

import { select_validator, donation_validator } from "../validators/validators";

import { environment } from "../environment";

import * as moment from "moment";
import { StripeCardStatus, CardHolder, StripeElementType } from '../models/stripe-account';

import "moment-timezone";

declare var $: any;
declare var paypal: any;
declare var PAYPAL: any;

declare var stripe: any;
declare var stripeElements: any;

@Component({
  selector: "payment",
  encapsulation: ViewEncapsulation.None,
  template: require('./payment.html'),
  styles: [require('./payment.scss'), require('../styles/main.scss')],
  providers: [DataService]
})
export class PaymentsComponent implements AfterViewInit, OnChanges, OnInit {
  @Input() first_name: string = "";
  @Input() last_name: string = "";
  @Input() email_address: string = "";
  @Input() org_name: string = "";
  @Input() phone_number: string = "";
  @Input() donation_total: number = 0;
  @Input() campaign_name: string = "";
  @Input() campaign_info: {} = {};
  @Input() donor_message: string = "";
  @Input() checkout_note: string = "";
  @Input() response_info: {} = {};
  @Input() merch_cart: {} = {};
  @Input() our_fee_percent: number = 0;
  @Input() name_on_card: string = "";
  @Input() anymoose: boolean = false;
  @Input() parent: any;

  @ViewChild("cardNumberElement") cardNumberElement: ElementRef;
  @ViewChild("cardExpiryElement") cardExpiryElement: ElementRef;
  @ViewChild("cardCvcElement") cardCvcElement: ElementRef;

  stripeCardNumberElement: any;
  stripeCardExpiryElement: any;
  stripeCardCvcElement: any;
  stripeCardStatus: StripeCardStatus;
  cardholder: CardHolder;
  afterViewInitCalled = false;
  onInitCalled = false;
  return_url: string = "";
  countries: any = {};

  // Display variables
  showPaypal: boolean = false;

  // Credit card details
  credit_card_form: FormGroup;
  shipping_form: FormGroup;

  // Shipping details
  shipping_country: string = "United States";
  shipping_address_1: string = "";
  shipping_address_2: string = "";
  shipping_city: string = "";
  shipping_state: string = "";
  shipping_postal: string = "";
  shipping_full: string = "";

  dgFlowMini: any;

  location_data: {} = { countries: [], states: {} };

  // Paypal related variables
  paypalInitialized: boolean = false;
  paykey: string;
  paypal_error: boolean = false;
  paypal_error_message: string = "";
  pending_donation_id: string;

  baseUrl: string = "";

  msgs: Message[] = [];
  msg_life: number;

  constructor(
    private builder: FormBuilder,
    private _dataservice: DataService,
    private detector: ChangeDetectorRef,
    private zone: NgZone
  ) {}

  ngOnInit() {
    if (this.onInitCalled) {
      return;
    }
    this.onInitCalled = true;
    this.stripeCardStatus = new StripeCardStatus();
    this.stripeCardNumberElement = stripeElements.create("cardNumber", { placeholder: "Card Number" });
    this.stripeCardExpiryElement = stripeElements.create("cardExpiry", { placeholder: "MM/YY" });
    this.stripeCardCvcElement = stripeElements.create("cardCvc", { placeholder: "CVC Security Code" });
    const updateStripeCardStatus = this.updateStripeCardStatus.bind(this);
    this.stripeCardNumberElement.on("change", updateStripeCardStatus);
    this.stripeCardExpiryElement.on("change", updateStripeCardStatus);
    this.stripeCardCvcElement.on("change", updateStripeCardStatus);

    const ch = new CardHolder();
    ch.address_city = ch.address_line1 = ch.address_line2 = ch.address_state = ch.address_zip = "";
    this.cardholder = ch;

      this.countries = this._dataservice.getCountriesDict();
  }

  ngAfterViewInit() {
    this.stripeCardNumberElement.mount(this.cardNumberElement.nativeElement);
    this.stripeCardExpiryElement.mount(this.cardExpiryElement.nativeElement);
    this.stripeCardCvcElement.mount(this.cardCvcElement.nativeElement);
    this._dataservice
      .processGet("/get-paypal-express-url")
      .subscribe(res => (this.baseUrl = res["x-paypal-express-url"]));

    var query = window.location.search.substring(1);
    if (query.startsWith("return_url=")) {
      // this.return_url = query.replace('return_url=', '');
      this.return_url = "&" + query;
    }
    if (this.afterViewInitCalled) {
      return;
    }
    this.afterViewInitCalled = true;
    this.cardholder.name = this.name_on_card;
  }
  ngOnDestroy() {
    this.stripeCardNumberElement.destroy();
    this.stripeCardExpiryElement.destroy();
    this.stripeCardCvcElement.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Form Control for the second page of the donation view
    this.credit_card_form = this.builder.group({
      zip_code: ["", <any>Validators.required],
      name_on_card: ["", <any>Validators.required],
      country: ["", <any>Validators.required]
    });

    if (!this.campaign_info["hide_shipping"]) {
      this.location_data["countries"] = this._dataservice.getCountries();
      this.location_data["states"] = this._dataservice.getStates();

      this.shipping_form = this.builder.group({
        //country: ['-- Select A Country', <any>Validators.required],
        us_fields: this.builder.group({
          address_line_1: ["", [<any>Validators.required, <any>Validators.minLength(5)]],
          address_line_2: ["", <any>Validators.minLength(5)],
          city: ["", [<any>Validators.required, <any>Validators.minLength(2)]],
          state: ["", [<any>Validators.required, select_validator]],
          postal_code: ["", <any>Validators.required]
        }),
        other_fields: this.builder.group({
          full_address: ["", [<any>Validators.required, <any>Validators.minLength(5)]]
        })
      });
    } else {
      this.shipping_form = this.builder.group({});
    }
  }

  updateStripeCardStatus = (event): void => {
    const elementType = event.elementType;
    delete event.elementType;
    this.stripeCardStatus[elementType] = event;
  };

  hasError(element: StripeElementType): boolean {
    return !!this.stripeCardStatus[element].error;
  }

  submitPayment() {
    if (this.parent.loading) {
      return;
    }

    var anonymous = false;
    var date_string = moment(new Date()).format("YYYY-MM-DD HH:mm");
    var formatted_date = moment.tz(date_string, moment.tz.guess()).format("MMMM Do, YYYY h:mm A");
    if (this.first_name === "" || this.first_name == null || this.anymoose) {
      anonymous = true;
    }
    var state = "";
    if (this.shipping_country === "United States") {
      var split = this.shipping_state;
    }

    if (this.donation_total > 0) {
      this.stripePayment(anonymous, formatted_date, state);
    } else if (this.campaign_info["campaign_type"] === "Event") {
      this.parent.loading = true;
      this._dataservice
        .submitPayment({
          token: "0dol",
          type: "donate",
          slug: this.campaign_name,
          amount: 0,
          currency: "USD",
          formatted_date: formatted_date,
          name: this.first_name + " " + this.last_name,
          email: this.email_address,
          org_name: this.org_name,
          phone_number: this.phone_number,
          message: this.donor_message,
          checkout_note: this.checkout_note,
          response_info: this.response_info,
          anonymous: anonymous,
          merch_cart: this.merch_cart,
          billing_zip_code: this.cardholder.address_zip,
          shipping_country: this.shipping_country,
          shipping_address_1: this.shipping_address_1,
          shipping_address_2: this.shipping_address_2,
          shipping_city: this.shipping_city,
          shipping_state: state,
          shipping_postal: this.shipping_postal,
          shipping_full: this.shipping_full
        })
        .subscribe(
          res => {
            localStorage.setItem("email", "");
            localStorage.setItem("first_name", "");
            localStorage.setItem("last_name", "");
            localStorage.setItem("amount", "");
            localStorage.setItem("org_name", "");
            localStorage.setItem("phone_number", "");
            localStorage.setItem("checkout_note", "");
            window.location.href = res.json()["success"] + this.return_url;
          },
          error => {
            this.parent.loading = false;
            this.msgs = [];
            this.msg_life = error_msg_len;
            this.msgs.push({ severity: "error", summary: "Error", detail: "Unable to process registration" });
          }
        );
    } else {
      this.msgs = [];
      this.msg_life = error_msg_len;
      this.msgs.push({ severity: "error", summary: "Error", detail: "Please enter a donation amount" });
    }
  }

  createToken(): Promise<any> {
    this.cardholder = {
      ...this.cardholder,
      address_line1: this.shipping_address_1,
      address_line2: this.shipping_address_2,
      address_city: this.shipping_city,
      address_state: this.shipping_state
    };
    try {
      return stripe.createToken(this.stripeCardNumberElement, this.cardholder);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  // Submits a credit card payment to stripe.
  async stripePayment(anonymous: boolean, formatted_date: string, state: string) {
    var _that = this;

    if (this.campaign_info["custom_prizes_enabled"]) {
      var prize_choice = (<HTMLInputElement>document.getElementById("prize_list")).value;
    }

    var amount = this.donation_total;
    if (this.parent.loading === true) {
      return;
    }
    this.parent.loading = true;

    // Creates a token by validating the credit card details with stripe
    const { token: cardToken, error } = await this.createToken();
    this.zone.run(() => {
      if (cardToken) {
        // Submits the transaction to the server to be executed
        var state = "";
        if (this.shipping_country === "United States") {
          state = this.shipping_state;
        }

        this._dataservice
          .submitPayment({
            token: cardToken.id,
            type: "donate",
            slug: this.campaign_name,
            amount: amount,
            currency: "USD",
            formatted_date: formatted_date,
            name: this.first_name + " " + this.last_name,
            email: this.email_address,
            org_name: this.org_name,
            phone_number: this.phone_number,
            message: this.donor_message,
            checkout_note: this.checkout_note,
            response_info: this.response_info,
            anonymous: anonymous,
            merch_cart: this.merch_cart,
            billing_zip_code: this.cardholder.address_zip,
            shipping_country: this.shipping_country,
            shipping_address_1: this.shipping_address_1,
            shipping_address_2: this.shipping_address_2,
            shipping_city: this.shipping_city,
            shipping_state: state,
            shipping_postal: this.shipping_postal,
            shipping_full: this.shipping_full
          })
          .subscribe(
            res => {
              localStorage.setItem("email", "");
              localStorage.setItem("first_name", "");
              localStorage.setItem("last_name", "");
              localStorage.setItem("amount", "");
              localStorage.setItem("org_name", "");
              localStorage.setItem("phone_number", "");
              localStorage.setItem("checkout_note", "");
              const response = res.json();
              if (response["success"] !== undefined) {
                window.location.href = res.json()["success"] + this.return_url;
              } else {
                console.error(response);
                this.parent.loading = false;
                this.msgs = [];
                this.msg_life = error_msg_len;
                this.msgs.push({ severity: "error", summary: "Error", detail: response });
              }
            },
            error => {
              this.parent.loading = false;
              this.msgs = [];
              this.msg_life = error_msg_len;
              this.msgs.push({
                severity: "error",
                summary: "Error",
                detail: "We are unable to process your payment at this time"
              });
            }
          );
      } else {
        this.parent.loading = false;
        this.msgs = [];
        this.msg_life = error_msg_len;
        this.msgs.push({ severity: "error", summary: "Error", detail: error.message });
        // this.detector.detectChanges();
      }
    });
  }

  initializePaypal() {
    this.parent.loading = true;
    this.showPaypal = true;
    var wc_cut = this.donation_total * this.our_fee_percent;
    var post_url: string = "/pp-ap-donation/" + this.campaign_info["_id"];
    var anonymous = false;

    if (this.first_name === "" || this.first_name == null || this.anymoose) {
      anonymous = true;
    }

    var date_string = moment(new Date()).format("YYYY-MM-DD HH:mm");

    var formatted_date = moment.tz(date_string, moment.tz.guess()).format("MMMM Do, YYYY h:mm A");

    var formdata = {
      email_address: this.email_address,
      org_name: this.org_name,
      phone_number: this.phone_number,
      first: this.first_name,
      last: this.last_name,
      created_date: new Date(),
      message: this.donor_message,
      checkout_note: this.checkout_note,
      response_info: this.response_info,
      anonymous: anonymous,
      merch_cart: this.merch_cart,
      return_url: this.return_url,
      amount: this.donation_total.toFixed(2),
      wc_cut: wc_cut.toFixed(2),
      formatted_date: formatted_date
    };

    this._dataservice.processPost(post_url, formdata).subscribe(
      res => {
        if (res["error"]) {
          console.error(res["error"]);
          this.cancelPaypal(res["error"]);
        } else {
          this.paykey = res["paykey"];
          if (this.paykey === "") {
            this.cancelPaypal("Invalid Paykey, Paypal is currently unavailable");
          } else {
            this.pending_donation_id = res["pending_id"];
          }
          this.parent.loading = false;
        }
      },
      error => {
        this.cancelPaypal("Paypal is currently unavailable");
      }
    );
  }

  cancelPaypal(cancelReason: string) {
    this.paypal_error_message = cancelReason;
    this.paypal_error = true;
    $("#paypal-unavailable-modal").modal();
    this.parent.loading = false;
  }

  useStripe() {
    (<HTMLInputElement>document.getElementById("radio-cc")).click();
  }

  processPaypal() {
    var dgUrl: string;
    this.parent.loading = true;
    // dgUrl = this.campaign_info['paypal_endpoint'] + '/webapps/adaptivepayment/flow/pay?expType=mini&payKey=' + this.paykey;
    // console.log('dgurl', dgUrl)

    dgUrl = this.baseUrl + "/webapps/adaptivepayment/flow/pay?expType=mini&payKey=" + this.paykey;
    this.dgFlowMini = new PAYPAL.apps.DGFlowMini({
      trigger: "submitBtn",
      expType: "mini",
      callbackFunction: "",
      callback_url: "/pp-ap-callback/" + this.pending_donation_id
    });
    this.dgFlowMini.startFlow(dgUrl);
    // this.dgFlowMini.startFlow('https://www.sandbox.paypal.com/webapps/adaptivepayment/flow/pay?expType=mini&payKey=' + this.paykey)
  }

  togglePaypal(enable: boolean) {
    if (enable) {
      if (this.campaign_info["paypal_enabled"] && !this.paypalInitialized) {
        var anonymous = false;

        // if(this.first_name === '' || this.first_name == null || (<HTMLInputElement>document.getElementById('anonymous')).checked) {
        //   anonymous = true;
        // }

        var payment_details = new Donation();
        var amount = this.donation_total;
        var prize_choice = "";
        var pending_donation_id: string = "";

        if (this.campaign_info["custom_prizes_enabled"]) {
          prize_choice = (<HTMLInputElement>document.getElementById("prize_list")).value;
        }

        var currency = (<HTMLInputElement>document.getElementById("currency_list")).value;
        // var add_on_data = '&campaignID=' + this.campaign_name +
        //                   '&first=' + this.first_name +
        //                   '&last=' + this.last_name +
        //                   '&message=' + encodeURI(this.donor_message) +
        //                   '&responses=' + encodeURI(JSON.stringify(this.response_info)) +
        //                   '&anonymous=' + anonymous +
        //                   '&question=' + encodeURI(this.wb_question);
        var pal_mode: string;
        if (environment.production) {
          pal_mode = "live";
        } else {
          pal_mode = "sandbox";
        }

        // Update the transaction details of the payment_details object
        payment_details.transactions[0].amount.total = amount.toFixed(2);
        payment_details.transactions[0].amount.currency = currency;
        payment_details.transactions[0].description = "Donation for " + this.campaign_name;
        payment_details.transactions[0].amount.details.subtotal = payment_details.transactions[0].amount.total;
        payment_details.transactions[0].item_list.items[0].name = "Donation Amount";
        payment_details.transactions[0].item_list.items[0].price = payment_details.transactions[0].amount.total;
        payment_details.transactions[0].item_list.items[0].currency = currency;
        payment_details.transactions[0].item_list.items[0].quantity = "1";

        var post_url: string = "/pending-donation/" + this.campaign_info["_id"];
        var formdata = {
          first: this.first_name,
          last: this.last_name,
          created_date: new Date(),
          message: this.donor_message,
          checkout_note: this.checkout_note,
          response_info: this.response_info,
          anonymous: anonymous,
          return_url: this.return_url,
          amount: amount.toFixed(2)
        };

        this._dataservice.processPost(post_url, formdata).subscribe(
          res => {
            if (res["error"]) {
              console.log(res["error"]);
            } else {
              pending_donation_id = res["pending_id"];

              if (pending_donation_id === "") {
                console.log("no valid pending donation id");
              }
              // Redirect urls for paypal after the transaction has been completed
              payment_details["redirect_urls"] = {
                return_url:
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/paypal-callback/?success=true&id=" +
                  pending_donation_id,
                cancel_url:
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/paypal-callback/?success=false&campaignID=" +
                  this.campaign_name
              };
              paypal.checkout.setup("CQUJNKJR5FPKL", {
                environment: pal_mode,
                container: "pp",
                click: function(event) {
                  event.preventDefault();

                  paypal.checkout.initXO();
                  $.support.cors = true;
                  $.ajax({
                    url: "/get-paypal-url",
                    type: "POST",
                    data: JSON.stringify(payment_details),
                    async: true,
                    crossDomain: true,

                    success: function(data) {
                      paypal.checkout.startFlow(data);
                      localStorage.setItem("email", "");
                      localStorage.setItem("first_name", "");
                      localStorage.setItem("last_name", "");
                      localStorage.setItem("amount", "");
                      localStorage.setItem("org_name", "");
                      localStorage.setItem("phone_number", "");
                      localStorage.setItem("checkout_note", "");
                    },
                    error: function(responseData, textStatus, errorThrown) {
                      alert("Error in ajax post" + responseData.statusText);
                      //Gracefully Close the minibrowser in case of AJAX errors
                      paypal.checkout.closeFlow();
                    }
                  });
                }
              });
            }
          },
          error => {
            this.parent.parent.loading = false;
            this.msgs = [];
            this.msg_life = error_msg_len;
            this.msgs.push({
              severity: "error",
              summary: "Error",
              detail: "We are unable to process your request at this time."
            });
          }
        );
      }
      this.paypalInitialized = true;
      this.showPaypal = true;
    } else {
      this.showPaypal = false;
    }
  }

  getKeys(dictionary) {
    return Object.keys(dictionary);
  }

  checkFormValidity() {
    let cc_valid: boolean;
    if (this.campaign_info["campaign_type"] !== "Event") {
      cc_valid = this.credit_card_form.valid;
    } else {
      // Check if the donation total is 0, if it is don't require the cc_fields
      if (this.donation_total <= 0) {
        cc_valid = true;
      } else {
        cc_valid = this.credit_card_form.valid;
      }
    }
    if (cc_valid) {
      if (this.campaign_info["hide_shipping"]) {
        return false;
      }
      if (this.shipping_form.controls["us_fields"].valid && this.shipping_form.controls["us_fields"].dirty)
        return false;
      else if (this.shipping_form.controls["other_fields"].valid && this.shipping_form.controls["other_fields"].dirty)
        return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/payments/payment.ts